app.controller("itemCtrl", [
  "$scope",
  "$location",
  "config",
  "$routeParams",
  "$localStorage",
  "cart",
  "checkUser",
  "ngMeta",
  "$q",
  "getSiteDetails",
  "ContentFactory",
  "FiveStreamApiFactory",
  function (
    $scope,
    $location,
    config,
    $routeParams,
    $localStorage,
    cart,
    checkUser,
    ngMeta,
    $q,
    getSiteDetails,
    ContentFactory,
    FiveStreamApiFactory
  ) {
    $scope.access = null;
    checkUser.checkLoginAndVerify(
      () => {
        $scope.loggedIn = true;
      },
      () => {
        $scope.access = false;
      }
    );

    $scope.contentID = $routeParams.contentID;
    $scope.showSubContents = false;
    var nowDate = new Date();
    var now = nowDate.getTime() / 1000;

    ContentFactory.getContentType($scope.contentID).then(function (
      contentType
    ) {
      $scope.contentType = contentType;
      ContentFactory.getContent($scope.contentID, contentType).then(function (
        content
      ) {
        if (!content) {
          toastr.error("This is item is no longer available");
          $location.path("/home");
          return;
        }
        checkTicket($scope.contentID).then(
          function (success) {
            if (content.cost === "0.00") {
              $scope.access = true;
            }
          },
          function (rejected) {
            if (content.cost === "0.00") {
              $scope.access = true;
            }
          }
        );
        $scope.details = content;
        if(content.typeTag){
          $scope.contentType = content.typeTag;
        }

        ngMeta.setTitle(content.title);
        $scope.poster = "https://" + content.poster;

        $scope.showSubContents = $scope.contentType == "subscription";

        if ($scope.contentType == "live") {
          var s = new Date(content.start * 1000);
          var syear = s.getFullYear();
          var smonth = s.toLocaleString("default", { month: "long" });
          var sday = s.getDate();
          var stime = s.getHours() + ":" + s.getMinutes() + ":00";

          var e = new Date(content.end * 1000);
          var eyear = e.getFullYear();
          var emonth = e.toLocaleString("default", { month: "long" });
          var eday = e.getDate();
          var etime = e.getHours() + ":" + e.getMinutes() + ":00";

          var timezone_offset_min = s.getTimezoneOffset();
          var offset_hrs = parseInt(Math.abs(timezone_offset_min / 60));
          var offset_min = Math.abs(timezone_offset_min % 60);

          if (timezone_offset_min > 0) {
            var calZone = "-" + pad(offset_hrs) + ":" + pad(offset_min);
          } else {
            var calZone = "+" + pad(offset_hrs) + ":" + pad(offset_min);
          }
          var startCal = smonth + " " + sday + ", " + syear + " " + stime;
          var endCal = emonth + " " + eday + ", " + eyear + " " + etime;

          //TODO - Add auth and make available for logged in users
          $("#addToCalBtn").addcalevent({
            apps: [1, 2, 3],
            ics: config.fstreamAPI + "getIcal",
            data: {
              title: content.title,
              desc: content.description,
              location: window.location.href,
              url: window.location.href,
              time: {
                start: startCal,
                end: endCal,
                zone: calZone,
              },
            },
          });
        } else {
          $(".calButton").hide();
          $("#startTime").hide();
        }
      });
    });

    $scope.addToCart = function () {
      if (
        $scope.details.end == undefined ||
        $scope.details.end == null ||
        $scope.details.end == 0 ||
        $scope.details.end - 300 > moment().unix()
      ) {
        let cartobj = {
          item: $scope.details.title,
          contentID: $scope.details.contentID,
          price: $scope.details.cost,
          currency: $scope.details.currency,
          discountItemID: 0,
          contentType: $scope.contentType,
        };

        cart.addToCart(cartobj, "/purchase");

        // $location.path("/purchase"); //TODO FIX THIS
      } else {
        toastr.error("This live stream has ended");
      }
    };

    function pad(n) {
      return n < 10 ? "0" + n : n;
    }

    function checkTicket(contentID) {
      let q = $q.defer();
      if ($scope.loggedIn !== true) {
        q.reject(false);
        return q.promise;
      }

      FiveStreamApiFactory.verifyCustomerOwnsContent(contentID)
        .then(() => {
          $scope.access = true;
          q.resolve(true);
        })
        .catch(() => {
          $scope.access = false;
          q.reject(false);
        });
      return q.promise;
    }
  },
]);
